export const LOAD_ACCOUNT_REPRESENTATIVES = 'load_account_representatives';
export const ACCOUNT_REPRESENTATIVES_LOADED = 'set_loaded_account_representatives';
export const RESET_ACCOUNT_REPRESENTATIVES = 'reset_account_representatives';
export const SYNC_FAILED = 'account_representatives_sync_error';
